/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { Component, ErrorInfo, ReactNode } from 'react';
import styled, { FlattenSimpleInterpolation } from 'styled-components';

import { ErrorBoundaryIcon } from './errorBoundaryIcon';
import { ErrorBoundaryInfo } from './errorBoundaryInfo';

interface Props {
  children: ReactNode;
  errorIconWidth?: number;
  errorIconHeight?: number;
  errorIconColor?: string;
  errorTitle?: string;
  errorDescription: string;
  customStyle?: FlattenSimpleInterpolation;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
      hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
      // Update state so the next render will show the fallback UI.
      return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
      console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
      if (this.state.hasError) {
          const { errorDescription, errorTitle, errorIconHeight, errorIconWidth, errorIconColor, customStyle } = this.props;
          return (
              <Container customStyle={customStyle}>
                  <ErrorBoundaryIcon width={errorIconWidth} height={errorIconHeight} fillColor={errorIconColor} />
                  <ErrorBoundaryInfo title={errorTitle} description={errorDescription}  />
              </Container>
          );
      }

      return this.props.children;
  }
}

interface ContainerProps {
    customStyle?: FlattenSimpleInterpolation;
}
const Container = styled.div<ContainerProps>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #F9F9F9;
    ${({ customStyle }) => customStyle && `${customStyle}`}
`;
